import '../../../../../styles/globals.css'
import { Box, Modal, Typography } from '@mui/material'
import { Grid } from '@mui/material';

import UsernameIconDisplay from '../UsernameIconDisplay';
import GetYoutubeCode from '../NoteUtils';
import LoveSectionComponent from '../LoveSectionComponent';
import NoteExpiryGridPiece from '../NoteExpiryGridPiece';
import DeleteNoteSectionComponent from '../DeleteNoteSectionComponent';

import { maxWidth } from '@mui/system';
import React from 'react';

const ReactMarkdown = require('react-markdown').default;

function ImageNoteComponent(props) {

    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <Box>
            <Grid container className='' spacing={0.5} sx={{
                width: "21.55rem",
                justifyContent: "center",
                alignItems: "center",
                padding: "0.5rem",
                margin: "0.25rem",
                backgroundColor: "rgba(221, 221, 221, 0.075)",
                borderRadius: "0.25rem",
                borderColor: "rgba(221, 221, 221, 0.25)",
                border: "1px solid rgba(221, 221, 221, 0.35)"
            }}>
                <Grid item xs={6} sm={6}>
                    <UsernameIconDisplay note={props.note} />
                </Grid>
                <DeleteNoteSectionComponent note={props.note} />
                <LoveSectionComponent note={props.note} />
                <Grid item xs={12} sm={12} sx={{ width: "100%", marginTop: "0.45rem", marginBottom: "0.5rem", justifyContent: "center", alignItems: "center", marginRight: "0.1rem" }}>
                    <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.625rem" }}>
                        <ReactMarkdown linkTarget="_blank" 
                            components={{
                                p: ({ children }) => (
                                    <Typography variant="body2" component="div" gutterBottom sx={{ marginBottom: "0.625rem" }}>
                                        {children}
                                    </Typography>
                                ),
                            }}
                        >
                            {props.note.text}
                        </ReactMarkdown>

                        <Box sx={{
                            width: "100%", display: "flex", justifyContent: "center", alignItems: "center"
                        }}>
                            <Box
                                onClick={handleOpen}
                                sx={{
                                    margin: 0,
                                    padding: 0,
                                    marginTop: "0.325rem",
                                    backgroundColor: "rgba(221, 221, 221, 0.075)",
                                    borderRadius: "0.25rem",
                                    width: "90%",
                                    maxWidth: "36rem"
                                }}>
                                <img
                                    src={"https://imagedelivery.net/VOV6-bP9OpL34z4U0gUIFw/" + props.note.extraFields.imageId + "/profilepicture512"}
                                    alt="profile-pic" width={"100%"} height={"100%"} />
                            </Box>
                            <Modal
                                open={open}
                                onClose={handleClose}
                                onClick={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                                sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%", padding: "1.0rem" }}
                            >
                                <Box sx={{
                                    margin: 0,
                                    padding: 0,
                                    marginTop: "0.325rem",
                                    borderRadius: "0.25rem",
                                    display: "flex",
                                    height: "100%",
                                    width: "100%",
                                    maxWidth: "36rem",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    outline: 'none'
                                }}>
                                    <img
                                        src={"https://imagedelivery.net/VOV6-bP9OpL34z4U0gUIFw/" + props.note.extraFields.imageId + "/fullsize"}
                                        alt="profile-pic"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            width: "auto",
                                            height: "auto",
                                        }}
                                    />
                                </Box>
                            </Modal>

                        </Box>
                    </Typography>
                </Grid>
                <NoteExpiryGridPiece note={props.note} neverExpires={props.neverExpires} />
                <Grid item xs={6} sm={6} sx={{ textAlign: "right", paddingRight: "1rem", padding: "0.5rem" }}>
                </Grid>
            </Grid>
        </Box >
    );
}

export default ImageNoteComponent;